// utils/token.js

export function getAccessToken() {
    return localStorage.getItem('accessToken');
  }
  
  export function setAccessToken(token) {
    localStorage.setItem('accessToken', token);
  }
  
  export function getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }
  
  export function setRefreshToken(token) {
    localStorage.setItem('refreshToken', token);
  }
  
  export function clearTokens() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userInfo');
  }
  